// extracted by mini-css-extract-plugin
module.exports = {"limiter":"Footer_limiter__2Dz2I","info":"Footer_info__BzFLJ","topButton":"Footer_topButton__7OPum","show":"Footer_show__234T1"};